import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

const PickingManagement = () => {
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Toplama Yönetimi
      </Typography>
      <Paper sx={{ p: 2 }}>
        <Typography>Toplama yönetimi burada görüntülenecek</Typography>
      </Paper>
    </Box>
  );
};

export default PickingManagement;
